import CareersCIEnvironment from "@/components/careers/careers-ci-environment";
import { Component } from "@builder.io/sdk";

export const careersCIEnvironmentConfig: Component = {
  name: "Careers CI Environment",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "ci-environment",
      helperText: "The ID of the CI environment section",
      advanced: true,
    },
    {
      name: "benefitsTitle",
      type: "string",
      defaultValue: "Benefits",
      helperText: "Title of the Benefits card",
    },
    {
      name: "benefitsDescription",
      type: "string",
      defaultValue: "As a part of our team, you are entitled to various perks",
      helperText: "Description of the Benefits card",
    },
    {
      name: "benefitsItems",
      type: "list",
      defaultValue: [
        {
          item: "Flexible scheduling",
        },
        {
          item: "Comprehensive benefits packages with 401(k) matching",
        },
        {
          item: "Paid mileage for travel",
        },
        {
          item: "Extensive training programs and 24/7 support",
        },
        {
          item: "Opportunities for career advancement",
        },
        {
          item: "Employee discounts with partner organizations",
        },
      ],
      subFields: [
        {
          name: "item",
          type: "string",
          defaultValue: "",
          helperText: "Benefits item text",
        },
      ],
      helperText: "List of benefits items to be displayed in the Benefits card",
    },
    {
      name: "qualificationsTitle",
      type: "string",
      defaultValue: "Qualifications",
      helperText: "Title of the Qualifications card",
    },
    {
      name: "qualificationsDescription",
      type: "string",
      defaultValue:
        "All Care Indeed employees uphold the highest levels of excellence",
      helperText: "Description of the Qualifications card",
    },
    {
      name: "qualificationsItems",
      type: "list",
      defaultValue: [
        {
          item: "Passion for working with seniors",
        },
        {
          item: "Cleared TB test & background check",
        },
        {
          item: "Legal authorization to work in the U.S.",
        },
        {
          item: "Proficient in English",
        },
        {
          item: "Comfortable using a smartphone",
        },
        {
          item: "Ability to assist clients with mobility and physical transfers",
        },
        {
          item: "Proof of COVID-19 vaccinations",
        },
      ],
      subFields: [
        {
          name: "item",
          type: "string",
          defaultValue: "",
          helperText: "Qualifications item text",
        },
      ],
      helperText:
        "List of qualifications items to be displayed in the Qualifications card",
    },
    {
      name: "responsibilitiesTitle",
      type: "string",
      defaultValue: "Responsibilities",
      helperText: "Title of the Responsibilities card",
    },
    {
      name: "responsibilitiesDescription",
      type: "string",
      defaultValue: "Lorem ipsum dolor sit amet consectetur.",
      helperText: "Description of the Responsibilities card",
    },
    {
      name: "responsibilitiesItems",
      type: "list",
      defaultValue: [
        {
          item: "Adhere to company policies and procedures",
        },
        {
          item: "Assist seniors with daily living activities",
        },
        {
          item: "Provide light housekeeping and meal preparation",
        },
        {
          item: "Support mobility and physical assistance",
        },
        {
          item: "Offer respectful companionship and meaningful conversation",
        },
      ],
      subFields: [
        {
          name: "item",
          type: "string",
          defaultValue: "",
          helperText: "Responsibilities item text",
        },
      ],
      helperText:
        "List of responsibilities items to be displayed in the Responsibilities card",
    },
    {
      name: "className",
      type: "string",
      defaultValue: "",
      helperText: "Additional CSS classes to apply to the component",
      advanced: true,
    },
  ],
};

export default CareersCIEnvironment;
